import React from 'react'
import {useForm} from 'react-hook-form'
import ComponentConfig, {
  ComponentConfigProps,
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {Panels, usePanelsUpdate} from 'Event/template/Panels'
import Styling from 'Event/template/Panels/Dashboard/RightPanel/RightPanelConfig/Styling'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import {useAutoUpdate} from 'organization/Event/TemplateEditor'

export default function RightPanelConfig(props: ComponentConfigProps) {
  const {showing: isVisible, onClose} = props

  const update = usePanelsUpdate()
  const {control, handleSubmit, formState, watch} = useForm()

  useAutoUpdate({
    values: {rightPanel: watch()},
    when: isVisible,
  })

  const submit = (data: Panels['rightPanel']) => {
    update({rightPanel: data})

    onClose()
  }

  return (
    <ComponentConfig
      showing={isVisible}
      onClose={onClose}
      title="Right Panel Config"
      onSubmit={handleSubmit(submit)}
      hasChanges={formState.isDirty}
    >
      <StylingPanel>
        <Styling control={control} />
      </StylingPanel>
      <Footer>
        <SaveButton type="submit" />
      </Footer>
    </ComponentConfig>
  )
}
